import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import styled from "styled-components"
import Container from "react-bootstrap/Container"
import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col"

import BackgroundImage from "gatsby-background-image"
import { device } from "../../utils/breakpoints"
import { colors } from "../../utils/theme"

import ModalRetoImage from "./ImageModalReto"

const Video = styled.div`
  position: relative;
  width: 100%;
  height: auto;
  margin-bottom: 1rem;
  opacity: inherit !important;
  @media ${device.md} {
    margin-bottom: 8rem;
    &:after {
      position: absolute;
      content: "";
      width: 90%;
      height: 400px;
      border: 2px solid ${colors.pColor};
      border-radius: 40px;
      top: 50%;
      left: 0;
      transform: translate(50px, -100px);
    }
  }
  & video {
    position: relative;
    margin: 0rem auto;
    width: 100%;
    border-radius: 10px;
    transform: translateY(50px);
    z-index: 1;
    &:focus {
      border: none;
      outline: none;
    }
    @media ${device.md} {
      border-radius: 30px;
      width: 80%;
      transform: translateY(100px);
      margin: 0 auto;
      display: block;
    }
  }
  & iframe {
    position: relative;
    display: block;
    margin: 0rem auto;
    width: 100%;
    height: 400px;
    border-radius: 10px;
    transform: translateY(50px);
    z-index: 1;
    &:focus {
      border: none;
      outline: none;
    }
    @media ${device.md} {
      border-radius: 30px;
      width: 80%;
      display: block;
      height: 500px;
      transform: translateY(100px);
      margin: 0 auto;
      display: block;
    }
  }
`

const RetoSection = styled(BackgroundImage)`
  width: 100%;
  background-position: bottom center;
  background-repeat: none;
  background-size: cover;
  opacity: inherit !important;
  @media ${device.md} {
    background-color: rgba(0, 0, 0, 0);
    background-position: bottom center;
    background-repeat: none;
    background-size: cover;
    opacity: inherit !important;
  }

  & .row-info {
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
    padding: 3rem 0 1rem 0;
    @media ${device.md} {
      padding: 3rem 0 9rem 0;
    }
    & .info {
      font-weight: 700;
      color: white;
      margin: 0;
      &-title {
        font-size: 1em;
        @media ${device.lg} {
          font-size: 2em;
        }
      }
      &-unete {
        font-weight: 800;
        text-transform: uppercase;
        color: ${colors.pColor};
        padding: 0.5em 1em;
        position: relative;
        margin: 2rem 0;
        font-size: 0.8em;
        line-height: 2em;
        @media ${device.lg} {
          background: transparent;
        }
        & span {
          padding: 0.5em 1em;
          position: relative;
          background: ${colors.sColor};
          @media ${device.lg} {
            font-size: 1.5em;
            background: transparent;
            &::after {
              background: ${colors.sColor};
              font-size: 2em;
              content: "";
              width: 100%;
              position: absolute;
              z-index: -1;
              transform: skew(-7deg);
              height: 100%;
              left: 0;
              top: 0;
            }
          }
        }
      }
      &-text{
        color: white;
        font-weight: 300;
        font-size: .8em;
        padding-top: 1rem;
        & strong{
          font-weight: 800;
          text-transform: uppercase;
        }
        & i{
          font-weight: 800;
          text-transform: uppercase;
          font-style: italic;
          color: ${colors.sColor}
        }
        @media ${device.md} {
          font-size: 1em;
        }
      }
    }
  }
`

const Reto = () => {
  const { image } = useStaticQuery(graphql`
    query {
      image: file(relativePath: { eq: "background-reto.jpg" }) {
        sharp: childImageSharp {
          fluid(quality: 80, maxWidth: 1920) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)
  return (
    <>
      <RetoSection
        tag="section"
        fluid={image.sharp.fluid}
        fadeIn="soft"
        backgroundColor={`#1a1a1a`}
        id="reto"
      >
        <Container>
          <Row className="justify-content-center row-info">
            <Col md={8} className="info text-center">
              <h4 className="info-title">
                ¿Cuanto llevas intentando aprender <strong>ZBRUSH </strong> y no
                has llegado al nivel deseado?
              </h4>
              <h5 className="info-unete">
                <span>Únete, aprende y gana premios</span>
              </h5>
              <ModalRetoImage />
              <p className="info-text">
                Estas listo para aumentar tu nivel en escultura digital con
                 <strong> ZBRUSH</strong>, unete a nuestro entrenamiento especializado donde juntos
                crearemos la escultura de un personaje <i>CYBERPUNK</i>, te enseñaremos
                tecnicas avanzadas para la producción de personajes en <strong>ZBRUSH</strong>.
              </p>
              <p className="info-text">
                Veremos conceptos de anatomia facial y corporal, definiremos el
                estilo de nuestro personaje <i>CYBERPUNK</i> usando referencias, las
                cuales te entregaremos para que inicies tu proceso de
                aprendizaje, aprenderás un flujo de trabajo guiado y soportado
                por la gran experiencia de nuestro instructor con el objetivo de
                implementarlo de manera correcta en la creación de personajes,
                accesorios y aplicación color en <strong>ZBRUSH</strong>.
              </p>
            </Col>
          </Row>
        </Container>
      </RetoSection>
    </>
  )
}

export default Reto
